export default {
  title: {
    id: 'bo_seller.listings.deals.banner.title',
    defaultMessage: 'Pay less, profit more with reduced commission deals',
  },
  description: {
    id: 'bo_seller.listings.deals.banner.description',
    defaultMessage:
      'Lock in limited-time reduced commission rates on selected products.',
  },
  downloadDealDetails: {
    id: 'bo_seller.listings.deals.banner.cta.download_deal_details',
    defaultMessage: 'Download deal details',
  },
  toggleDealsList: {
    id: 'bo_seller.listings.deals.banner.a11y.toggle_deals_list',
    defaultMessage: 'Toggle deals list',
  },
  seeHowItWorks: {
    id: 'bo_seller.listings.deals.banner.link.see_how_it_works',
    defaultMessage: 'See how it works',
  },
  activeDealsTag: {
    id: 'bo_seller.listings.deals.banner.tag.active_deals',
    defaultMessage: '{count} active',
  },
  dealEndsIn: {
    id: 'bo_seller.listings.deals.banner.deal_expiry.deal_ends_in',
    defaultMessage: 'Deal ends:',
  },
  daysLeft: {
    id: 'bo_seller.listings.deals.banner.deal_expiry.days_left',
    defaultMessage: '{days} days left',
  },
  dealEndsTomorrow: {
    id: 'bo_seller.listings.deals.banner.deal_expiry.deal_ends_tomorrow',
    defaultMessage: 'Tomorrow',
  },
  dealEndsToday: {
    id: 'bo_seller.listings.deals.banner.deal_expiry.deal_ends_today',
    defaultMessage: 'Today',
  },
  dealDetailsDownloading: {
    id: 'bo_seller.listings.deals.banner.toast.deal_details_downloading',
    defaultMessage: 'Deal details downloading',
  },
  dealDetailsDownloadingContent: {
    id: 'bo_seller.listings.deals.banner.toast.deal_details_downloading_content',
    defaultMessage: 'You can view your download in the file library shortly',
  },
  dealDetailsFileLibraryAction: {
    id: 'bo_seller.listings.deals.banner.toast.deal_details_file_library_action',
    defaultMessage: 'Open file library',
  },
  dealDetailsDownloadingError: {
    id: 'bo_seller.listings.deals.banner.toast.deal_details_downloading_error',
    defaultMessage: 'Error downloading deal details',
  },
}
